/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var mirai = {
    // All pages
    'common': {
      init: function() {

		// Hide Sub Menu when clicking outside 

		$(document).click(function (e) {
			if (document.documentElement.clientWidth > 900) {
			    var container = $("#primary-menu");

			    //check if the clicked area is dropDown or not
			    if (container.has(e.target).length === 0) {
			        $('#primary-menu li, .sub-menu').removeClass('menu-active');
			    }
			}
		});

		// Reset nav on window resize

		$(window).resize(function() {
		    var width = $(document).width();
		    if (width < 900) {
				$('body, .nav-mobile, .mobile-trigger span').removeClass('mobile-menu-active');
			}
		});​

		$('#primary-menu > li').click(function() {
		    var $this = $(this),
		        $ul   = $('> ul', this);
		    
		    if (!$ul.hasClass('menu-active')) {

				// Add class to current list item 
				$this.addClass('menu-active');

		        // Slide down used for mobiles
				$ul.toggleClass('menu-active').slideDown();

		    } else {

		    	$this.removeClass('menu-active');

		    	$ul.removeClass('menu-active');

		    }
		});

		$('.mobile-trigger').click(function() {
			$(this).find('span').toggleClass('mobile-menu-active');
			$('body, .nav-mobile').toggleClass('mobile-menu-active');
		});

		$('.product-menu li a').click(function(){
			$('div article').hide();
			var tmp_div = $(this).parent().index();
			$('div article').eq(tmp_div).show();
		});

        function close_accordion_section() {
          $('.shire-accordion .shire-accordion__section__title').removeClass('active');
          $('.shire-accordion .shire-accordion__section__content').stop().slideUp(300).removeClass('open');
        }

        $('.shire-accordion__section__title').click(function(e) {
          // Grab current anchor value
          var currentAttrValue = $(this).attr('href');

          if($(e.target).is('.active')) {
            close_accordion_section();
          } else {
            close_accordion_section();
            // Add active class to section title
            $(this).addClass('active');
            // Open up the hidden content panel
            $('.shire-accordion__section__content' + currentAttrValue).stop().slideDown(300).addClass('open'); 
          }

          e.preventDefault();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

  		var time = 5; // time in seconds

		var $progressBar,
		$bar, 
		$elem, 
		isPause, 
		tick,
		percentTime;

		//Init the Main Slider
		$(".hero-area__slider").owlCarousel({
			slideSpeed : 500,
			singleItem : true,
			navigation: true,
			pagination: false,
			mouseDrag : false,
			touchDrag : false,
			afterMove : moved,
			afterInit: progressBar
		});
	 
	    //Init progressBar where elem is $("#owl-demo")
	    function progressBar(elem){
	      $elem = elem;
	      //build progress bar elements
	      buildProgressBar();
	      //start counting
	      start();

			$.each(this.owl.userItems, function (i) {
				var titleData = jQuery(this).find('img').attr('title');
				var paginationLinks = jQuery('.owl-controls .owl-pagination .owl-page span');
				$(paginationLinks[i]).append(titleData);
			});
	    }
	 
	    //create div#progressBar and div#bar then prepend to $("#owl-demo")
	    function buildProgressBar(){
	      $progressBar = $("<div>",{
	        id:"progressBar"
	      });
	      $bar = $("<div>",{
	        id:"bar"
	      });
	      $progressBar.append($bar).prependTo($elem);
	    }
	 
	    function start() {
	      //reset timer
	      percentTime = 0;
	      isPause = false;
	      //run interval every 0.01 second
	      tick = setInterval(interval, 10);
	    };
	 
	    function interval() {
	      if(isPause === false){
	        percentTime += 1 / time;
	        $bar.css({
	           width: percentTime+"%"
	         });
	        //if percentTime is equal or greater than 100
	        if(percentTime >= 100){
	          //slide to next item 
	          $elem.trigger('owl.next')
	        }
	      }
	    }
	 
	    //pause while dragging 
	    function pauseOnDragging(){
	      isPause = true;
	    }
	 
	    //moved callback
	    function moved(){
	      //clear interval
	      clearTimeout(tick);
	      //start again
	      start();
	    }

		$elem.on('mouseover',function(){
			isPause = true;
	    });
	    $elem.on('mouseout',function(){
	    	isPause = false;
	    });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'contact_us': {
    	init: function() {
			function new_map( $el ) {
				
				// var
				var $markers = $el.find('.marker');

				// Styles
				var styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
				
				// vars
				var args = {
					zoom		: 10,
					center		: new google.maps.LatLng(0, 0),
					scrollwheel	: false,
					mapTypeId	: google.maps.MapTypeId.ROADMAP,
					styles: styles
				};
				
				// create map	        	
				var map = new google.maps.Map( $el[0], args);
				
				// add a markers reference
				map.markers = [];
				
				// add markers
				$markers.each(function(){
					
			    	add_marker( $(this), map );
					
				});
				
				// center map
				center_map( map );
				
				// return
				return map;
				
			}

			// create info window outside of loop
			var infowindow = new google.maps.InfoWindow({maxWidth	: 307});

			function add_marker( $marker, map ) {

				// var
				var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

				// create marker
				var marker = new google.maps.Marker({
					position	: latlng,
					map			: map
				});

				// add to array
				map.markers.push( marker );

				// if marker contains HTML, add it to an infoWindow
				if( $marker.html() )
				{
					// show info window when marker is clicked
					google.maps.event.addListener(marker, 'click', function() {
						infowindow.setContent( $marker.html() );
						infowindow.open( map, marker);

					});
				}

			}

			function center_map( map ) {

				// vars
				var bounds = new google.maps.LatLngBounds();

				// loop through all markers and create bounds
				$.each( map.markers, function( i, marker ){

					var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

					bounds.extend( latlng );

				});

				// only 1 marker?
				if( map.markers.length == 1 )
				{
					// set center of map
				    map.setCenter( bounds.getCenter() );
				    map.setZoom( 10 );
				}
				else
				{
					// fit to bounds
					map.fitBounds( bounds );
				}

			}

			var map = null;

			$('.acf-map').each(function(){
				// create map
				map = new_map( $(this) );
			});
    	}
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = mirai;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
